import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { LegalPage, P, UL } from "@/components/marketing/LegalPage";

export const Route = createFileRoute("/legal/aml-vietnam")({
  head: () => ({
    meta: [
      { title: "Phòng Chống Rửa Tiền & Tội Phạm Tài Chính (Việt Nam) — banana.cards" },
      { name: "description", content: "Điều khoản phòng chống rửa tiền, chống tài trợ khủng bố, kiểm soát danh sách hạn chế và phòng chống tội phạm tài chính của Banana Cards Việt Nam." },
      { property: "og:title", content: "Phòng Chống Rửa Tiền & Tội Phạm Tài Chính (Việt Nam) — banana.cards" },
      { property: "og:description", content: "Điều khoản AML/CFT, kiểm soát danh sách hạn chế và phòng chống tội phạm tài chính dành cho Đơn Vị Tổ Chức tại Việt Nam." },
    ],
    links: alternateLinkList("/legal/aml-vietnam", "en"),
  }),
  component: AmlVietnamPage,
});

export function AmlVietnamPage() {
  return (
    <LegalPage
      eyebrow="Pháp lý · Tuân thủ"
      title="Phòng Chống Rửa Tiền &"
      italic="Tội Phạm Tài Chính."
      updated="Tháng 01 năm 2026"
      intro="Đơn Vị Tổ Chức đồng ý rằng Banana Cards Việt Nam có quyền thực hiện các biện pháp kiểm tra, xác minh, rà soát, giám sát và kiểm soát cần thiết hoặc phù hợp nhằm phòng chống rửa tiền, chống tài trợ khủng bố, chống tài trợ phổ biến vũ khí hủy diệt hàng loạt, phòng chống gian lận, phòng chống giao dịch bất hợp pháp, phòng chống trốn thuế, quản lý rủi ro thanh toán và tuân thủ các nghĩa vụ pháp luật có liên quan. Các biện pháp này có thể được áp dụng trước, trong và sau khi sự kiện diễn ra."
      related={[
        { label: "AML — Global", to: "/legal/aml-global" },
        { label: "KYC — Việt Nam", to: "/legal/kyc-vietnam" },
        { label: "Điều Khoản Bán Vé (Việt Nam)", to: "/legal/ticketing-vietnam" },
      ]}
      sections={[
        {
          id: "tuan-thu",
          title: "1. Tuân Thủ Quy Định Pháp Luật Về Phòng Chống Rửa Tiền",
          body: (
            <>
              <P>Đơn Vị Tổ Chức phải tuân thủ tất cả quy định pháp luật hiện hành liên quan đến:</P>
              <UL items={[
                "phòng, chống rửa tiền",
                "chống tài trợ khủng bố",
                "chống tài trợ phổ biến vũ khí hủy diệt hàng loạt",
                "phòng chống gian lận",
                "phòng chống hối lộ, tham nhũng và các hành vi bất hợp pháp",
                "phòng chống trốn thuế hoặc che giấu nghĩa vụ thuế",
                "giao dịch đáng ngờ",
                "nguồn tiền bất hợp pháp",
                "tội phạm tài chính",
                "quy định của ngân hàng, cổng thanh toán, tổ chức thẻ, ví điện tử và nhà cung cấp dịch vụ thanh toán",
              ]} />
              <P>Khi áp dụng, các nghĩa vụ này bao gồm quy định tại Luật Phòng, chống rửa tiền, các nghị định và thông tư hướng dẫn, quy định của Ngân hàng Nhà nước Việt Nam, quy định của cơ quan có thẩm quyền, quy định của tổ chức thanh toán và các quy định pháp luật khác có liên quan.</P>
            </>
          ),
        },
        {
          id: "cam-ket",
          title: "2. Cam Kết của Đơn Vị Tổ Chức",
          body: (
            <>
              <P>Đơn Vị Tổ Chức cam kết và bảo đảm rằng:</P>
              <UL items={[
                "không sử dụng Banana Cards để rửa tiền, che giấu nguồn tiền, tài trợ khủng bố, tài trợ tổ chức bất hợp pháp, tài trợ phổ biến vũ khí hủy diệt hàng loạt, thực hiện gian lận hoặc hỗ trợ hoạt động bất hợp pháp",
                "Đơn Vị Tổ Chức, người đại diện, người được ủy quyền, cổ đông, chủ sở hữu hưởng lợi, đơn vị liên kết, nhà tài trợ, Đơn Vị Triển Lãm hoặc đối tác chính không thuộc danh sách bị hạn chế, bị phong tỏa, bị cấm giao dịch hoặc bị xử lý theo quy định pháp luật",
                "mọi khoản tiền thu được phát sinh từ hoạt động sự kiện hợp pháp, có mục đích thương mại rõ ràng và phù hợp với nội dung sự kiện đã công bố",
                "doanh thu vé, doanh thu Đơn Vị Triển Lãm, phí gian hàng, phí tài trợ và các khoản thu khác không phải là tiền hoặc tài sản có nguồn gốc từ hành vi phạm tội",
                "không cấu trúc, chia nhỏ, che giấu, đảo vòng hoặc sắp xếp giao dịch nhằm né tránh quy trình xác minh, kiểm soát thanh toán, kiểm tra rủi ro, nghĩa vụ thuế, nghĩa vụ báo cáo hoặc quy định pháp luật",
                "cung cấp đầy đủ, chính xác và kịp thời mọi thông tin, tài liệu và bằng chứng mà Banana Cards yêu cầu hợp lý cho mục đích xác minh, thanh toán, đối soát, thuế, phòng chống gian lận, phòng chống rửa tiền hoặc tuân thủ pháp luật",
              ]} />
            </>
          ),
        },
        {
          id: "nhan-biet",
          title: "3. Nhận Biết và Xác Minh Đơn Vị Tổ Chức",
          body: (
            <>
              <P>Banana Cards có thể yêu cầu Đơn Vị Tổ Chức cung cấp thông tin và tài liệu phục vụ việc nhận biết khách hàng, xác minh doanh nghiệp, xác minh chủ sở hữu hưởng lợi, xác minh người đại diện, xác minh tài khoản ngân hàng, xác minh thuế và đánh giá rủi ro. Các thông tin và tài liệu có thể bao gồm:</P>
              <UL items={[
                "tên pháp lý và tên thương mại",
                "giấy chứng nhận đăng ký doanh nghiệp, giấy phép hoạt động hoặc tài liệu tương đương",
                "mã số thuế",
                "địa chỉ đăng ký và địa chỉ hoạt động",
                "thông tin người đại diện theo pháp luật và người được ủy quyền quản lý tài khoản hoặc sự kiện",
                "thông tin cổ đông, thành viên góp vốn, chủ sở hữu hưởng lợi hoặc bên kiểm soát thực tế",
                "giấy tờ định danh của cá nhân đại diện, người được ủy quyền hoặc chủ sở hữu hưởng lợi khi cần thiết",
                "thông tin tài khoản ngân hàng và bằng chứng tài khoản thuộc về Đơn Vị Tổ Chức",
                "thông tin nguồn tiền, mục đích giao dịch hoặc cơ sở thương mại của sự kiện khi cần thiết",
                "hợp đồng, báo giá, hóa đơn, chứng từ thanh toán, danh sách Đơn Vị Triển Lãm, danh sách nhà tài trợ hoặc tài liệu liên quan",
              ]} />
              <P>Banana Cards có thể từ chối phê duyệt tài khoản, trì hoãn việc xuất bản sự kiện, hạn chế chức năng bán vé, tạm dừng thu thanh toán hoặc trì hoãn giải ngân nếu thông tin được yêu cầu không được cung cấp, không đầy đủ, không chính xác, không nhất quán, hết hiệu lực, không thể xác minh hoặc có dấu hiệu rủi ro cao.</P>
            </>
          ),
        },
        {
          id: "giam-sat",
          title: "4. Giám Sát Giao Dịch và Hoạt Động Sự Kiện",
          body: (
            <>
              <P>Banana Cards có thể giám sát tài khoản, sự kiện, giao dịch bán vé, thanh toán của Đơn Vị Triển Lãm, yêu cầu hoàn tiền, chargeback, yêu cầu giải ngân, thay đổi tài khoản ngân hàng, dữ liệu check-in và các hoạt động trên nền tảng để phát hiện hành vi bất thường, đáng ngờ, gian lận, rủi ro cao hoặc bị cấm. Các dấu hiệu có thể dẫn đến việc rà soát bao gồm:</P>
              <UL items={[
                "doanh số vé hoặc doanh thu bất thường so với loại sự kiện, quy mô địa điểm hoặc năng lực tổ chức",
                "số lượng giao dịch hoàn tiền cao bất thường",
                "sự kiện bị hủy nhiều lần sau khi đã thu tiền",
                "tỷ lệ chargeback hoặc tranh chấp thanh toán cao",
                "thanh toán từ nhiều thẻ, nhiều tài khoản hoặc nhiều nguồn không rõ ràng nhưng yêu cầu giải ngân về một tài khoản",
                "yêu cầu giải ngân đến tài khoản không đứng tên Đơn Vị Tổ Chức",
                "thay đổi tài khoản ngân hàng ngay trước thời điểm giải ngân",
                "nội dung sự kiện không phù hợp với loại giao dịch hoặc dòng tiền thực tế",
                "khoản thanh toán từ Đơn Vị Triển Lãm, nhà tài trợ hoặc đối tác có giá trị bất thường nhưng không có cơ sở thương mại rõ ràng",
                "yêu cầu chia nhỏ giao dịch, hóa đơn, thanh toán hoặc giải ngân không có lý do hợp lý",
                "từ chối cung cấp tài liệu, cung cấp tài liệu không nhất quán hoặc yêu cầu Banana Cards bỏ qua quy trình kiểm tra",
                "bất kỳ hành vi nào mà Banana Cards có cơ sở hợp lý để xem là không phù hợp với hoạt động bán vé, tổ chức sự kiện hoặc quản lý Đơn Vị Triển Lãm thông thường",
              ]} />
            </>
          ),
        },
        {
          id: "danh-sach-han-che",
          title: "5. Kiểm Tra Danh Sách Hạn Chế và Đối Tượng Rủi Ro",
          body: (
            <>
              <P>Banana Cards có thể kiểm tra Đơn Vị Tổ Chức, người đại diện, người được ủy quyền, chủ sở hữu hưởng lợi, Đơn Vị Triển Lãm, nhà tài trợ, người thanh toán, người nhận thanh toán và các bên liên quan đến sự kiện theo danh sách cảnh báo, danh sách bị hạn chế, danh sách cấm giao dịch, danh sách trừng phạt, cơ sở dữ liệu về người có ảnh hưởng chính trị, thông tin bất lợi trên truyền thông hoặc các nguồn tuân thủ khác.</P>
              <P>Banana Cards có thể chặn, từ chối, tạm giữ, trì hoãn, đảo, hoàn hoặc không thực hiện giao dịch, thanh toán, giải ngân, hoàn tiền, xuất bản sự kiện hoặc cung cấp dịch vụ nếu Banana Cards có cơ sở hợp lý cho rằng việc tiếp tục giao dịch có thể vi phạm pháp luật, quy định thanh toán hoặc chính sách quản lý rủi ro.</P>
            </>
          ),
        },
        {
          id: "kiem-soat-giai-ngan",
          title: "6. Kiểm Soát Giải Ngân",
          body: (
            <>
              <P>Banana Cards có thể trì hoãn, tạm giữ, tạm dừng, từ chối hoặc hủy giải ngân trong các trường hợp sau:</P>
              <UL items={[
                "Đơn Vị Tổ Chức chưa hoàn tất xác minh",
                "thông tin chủ sở hữu hưởng lợi, người đại diện, người được ủy quyền hoặc tài khoản ngân hàng chưa được cung cấp hoặc chưa được xác minh",
                "tài khoản ngân hàng nhận tiền không thuộc về Đơn Vị Tổ Chức hoặc không thể xác minh",
                "giao dịch hoặc sự kiện có dấu hiệu đáng ngờ, bất thường, gian lận hoặc rủi ro cao",
                "ngân hàng, cổng thanh toán, tổ chức thẻ, ví điện tử, cơ quan nhà nước, tòa án, cơ quan điều tra hoặc cơ quan có thẩm quyền yêu cầu hoặc buộc tạm giữ",
                "đang có quy trình rà soát về phòng chống rửa tiền, chống tài trợ khủng bố, gian lận, chargeback, thuế, hóa đơn, tranh chấp hoặc pháp lý",
                "Đơn Vị Tổ Chức, Khách Hàng, Đơn Vị Triển Lãm, nhà tài trợ hoặc bên liên quan có dấu hiệu nằm trong danh sách hạn chế, bị phong tỏa, danh sách cảnh báo hoặc nhóm rủi ro cao",
                "Banana Cards có cơ sở hợp lý để cho rằng việc giải ngân có thể vi phạm pháp luật, quy định của nhà cung cấp thanh toán, nghĩa vụ tuân thủ hoặc chính sách quản lý rủi ro",
              ]} />
              <P>Banana Cards không chịu trách nhiệm đối với việc trì hoãn, tạm giữ, tạm dừng, từ chối hoặc hủy giải ngân nếu hành động đó được thực hiện một cách thiện chí nhằm tuân thủ pháp luật, yêu cầu của ngân hàng/cổng thanh toán, yêu cầu của cơ quan có thẩm quyền, quy định phòng chống rửa tiền, chống tài trợ khủng bố, phòng chống gian lận hoặc quản lý rủi ro thanh toán.</P>
            </>
          ),
        },
        {
          id: "giao-dich-dang-ngo",
          title: "7. Giao Dịch Đáng Ngờ và Cung Cấp Thông Tin",
          body: (
            <>
              <P>Nếu Banana Cards phát hiện hoặc có cơ sở hợp lý để nghi ngờ giao dịch, sự kiện, khoản thanh toán, yêu cầu hoàn tiền, yêu cầu giải ngân hoặc hoạt động tài khoản có liên quan đến rửa tiền, tài trợ khủng bố, gian lận, nguồn tiền bất hợp pháp hoặc hành vi vi phạm pháp luật, Banana Cards có thể:</P>
              <UL items={[
                "yêu cầu Đơn Vị Tổ Chức cung cấp thêm thông tin hoặc tài liệu giải trình",
                "tạm dừng sự kiện, chức năng bán vé, chức năng thu thanh toán, chức năng quản lý Đơn Vị Triển Lãm hoặc giải ngân",
                "giữ lại khoản thanh toán hoặc khoản dự phòng trong thời gian cần thiết để rà soát",
                "từ chối xử lý giao dịch, hoàn tiền, giải ngân hoặc dịch vụ liên quan",
                "cung cấp thông tin, hồ sơ, tài liệu hoặc báo cáo cho ngân hàng, cổng thanh toán, tổ chức thẻ, cơ quan nhà nước, cơ quan điều tra, cơ quan thuế, cơ quan phòng chống rửa tiền hoặc cơ quan có thẩm quyền khi pháp luật yêu cầu hoặc cho phép",
              ]} />
              <P>Banana Cards có thể thực hiện các biện pháp trên mà không cần thông báo trước nếu việc thông báo có thể bị pháp luật hạn chế, ảnh hưởng đến quá trình xác minh/điều tra, tạo rủi ro tiết lộ thông tin, làm tăng rủi ro pháp lý hoặc rủi ro tội phạm tài chính.</P>
            </>
          ),
        },
        {
          id: "hanh-vi-bi-cam",
          title: "8. Hành Vi Bị Cấm",
          body: (
            <>
              <P>Đơn Vị Tổ Chức không được sử dụng Banana Cards cho:</P>
              <UL items={[
                "sự kiện giả, sự kiện không có thật hoặc sự kiện được tạo chủ yếu để luân chuyển tiền",
                "giao dịch không có mục đích thương mại hợp pháp",
                "rửa tiền hoặc che giấu nguồn gốc tài sản",
                "tài trợ khủng bố hoặc tài trợ tổ chức bất hợp pháp",
                "tài trợ phổ biến vũ khí hủy diệt hàng loạt",
                "gian lận thanh toán, thử thẻ, lạm dụng hoàn tiền hoặc lạm dụng chargeback",
                "hối lộ, tham nhũng hoặc tài trợ bất hợp pháp",
                "cờ bạc, cá cược, xổ số hoặc trò chơi có thưởng không được cấp phép",
                "mô hình đầu tư trái phép, mô hình đa cấp trái phép, huy động vốn trái phép hoặc gây hiểu nhầm",
                "bán hàng hóa hoặc dịch vụ bị cấm",
                "cố tình thổi phồng doanh thu vé, phí Đơn Vị Triển Lãm, phí tài trợ hoặc phí gian hàng để hợp thức hóa dòng tiền",
                "nhận tiền thay cho bên thứ ba mà không thông báo và không được Banana Cards chấp thuận",
                "che giấu người thanh toán, người nhận thanh toán, chủ sở hữu hưởng lợi, nguồn tiền, mục đích giao dịch hoặc mục đích sự kiện",
                "sử dụng tài khoản, pháp nhân, người đại diện, người được ủy quyền hoặc tài khoản ngân hàng của bên thứ ba nhằm né tránh quy trình xác minh hoặc kiểm soát tuân thủ",
              ]} />
            </>
          ),
        },
        {
          id: "hop-tac",
          title: "9. Nghĩa Vụ Hợp Tác",
          body: (
            <>
              <P>Đơn Vị Tổ Chức phải hợp tác kịp thời với Banana Cards trong mọi quy trình rà soát tuân thủ, điều tra thanh toán, điều tra chargeback, kiểm tra gian lận, kiểm tra phòng chống rửa tiền, kiểm tra chống tài trợ khủng bố, kiểm tra thuế, kiểm tra hóa đơn hoặc yêu cầu từ cơ quan có thẩm quyền.</P>
              <P>Việc không hợp tác, chậm hợp tác hoặc cung cấp thông tin sai lệch có thể dẫn đến việc tạm dừng sự kiện, hạn chế tài khoản, trì hoãn hoặc từ chối giải ngân, chấm dứt dịch vụ, cung cấp thông tin cho cơ quan có thẩm quyền hoặc áp dụng các biện pháp khác được phép theo các Điều Khoản này.</P>
            </>
          ),
        },
        {
          id: "tam-dung-cham-dut",
          title: "10. Quyền Tạm Dừng hoặc Chấm Dứt",
          body: (
            <>
              <P>Banana Cards có thể tạm dừng, hạn chế, gián đoạn hoặc chấm dứt tài khoản, sự kiện, chức năng bán vé, chức năng thu thanh toán, chức năng quản lý Đơn Vị Triển Lãm, việc xuất bản sự kiện, việc giải ngân, phối hợp hóa đơn, kiểm soát truy cập, hỗ trợ check-in hoặc bất kỳ dịch vụ nền tảng liên quan nào nếu Banana Cards có cơ sở hợp lý để cho rằng:</P>
              <UL items={[
                "Đơn Vị Tổ Chức vi phạm điều khoản về phòng chống rửa tiền, chống tài trợ khủng bố hoặc phòng chống tội phạm tài chính",
                "Đơn Vị Tổ Chức cung cấp thông tin sai, không đầy đủ, gây hiểu nhầm, không nhất quán hoặc không thể xác minh",
                "sự kiện, giao dịch, Khách Hàng, Đơn Vị Triển Lãm, nhà tài trợ hoặc bên liên quan tạo ra rủi ro không thể chấp nhận về AML/CFT, gian lận, chargeback, thanh toán, thuế, pháp lý hoặc uy tín",
                "việc tiếp tục cung cấp dịch vụ có thể vi phạm pháp luật, quy định của ngân hàng/cổng thanh toán, yêu cầu của cơ quan có thẩm quyền hoặc chính sách kiểm soát rủi ro của Banana Cards",
                "Banana Cards được yêu cầu hoặc được khuyến nghị thực hiện việc tạm dừng, hạn chế hoặc chấm dứt bởi ngân hàng, cổng thanh toán, tổ chức thẻ, ví điện tử, cơ quan nhà nước, tòa án, cơ quan điều tra hoặc cơ quan có thẩm quyền",
              ]} />
            </>
          ),
        },
        {
          id: "khong-ne-tranh",
          title: "11. Không Né Tránh Kiểm Soát",
          body: (
            <>
              <P>Đơn Vị Tổ Chức không được cố gắng né tránh quy trình xác minh, kiểm soát giải ngân, kiểm soát thanh toán, kiểm tra rủi ro, kiểm tra danh sách hạn chế, giám sát giao dịch hoặc các biện pháp phòng chống rửa tiền của Banana Cards.</P>
              <P>Mọi hành vi sử dụng tài khoản thay thế, danh tính giả, pháp nhân thay thế, tài khoản ngân hàng của bên thứ ba chưa được chấp thuận, cấu trúc sự kiện giả tạo, chia nhỏ giao dịch, hủy sự kiện lặp lại, mô tả sai nội dung sự kiện hoặc che giấu mục đích giao dịch sẽ được xem là vi phạm nghiêm trọng các Điều Khoản này.</P>
            </>
          ),
        },
        {
          id: "luu-giu",
          title: "12. Lưu Giữ Hồ Sơ và Thời Hạn Hiệu Lực",
          body: (
            <>
              <P>Banana Cards có thể lưu giữ hồ sơ xác minh, thông tin giao dịch, báo cáo đối soát, lịch sử thanh toán, hồ sơ giải ngân, thông tin tài khoản, tài liệu sự kiện và các dữ liệu liên quan trong thời hạn cần thiết để phục vụ mục đích pháp lý, kế toán, thuế, phòng chống gian lận, phòng chống rửa tiền, giải quyết tranh chấp, chargeback hoặc tuân thủ yêu cầu của cơ quan có thẩm quyền.</P>
              <P>Các nghĩa vụ trong điều khoản này tiếp tục có hiệu lực sau khi sự kiện kết thúc, tài khoản bị đóng, khoản thanh toán đã được giải ngân, dịch vụ bị tạm dừng hoặc quan hệ giữa Đơn Vị Tổ Chức và Banana Cards chấm dứt.</P>
            </>
          ),
        },
      ]}
    />
  );
}